import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CaseService } from '../../services/case.service';
import { PrintDesionService } from '../../services/print-decsion.service';
import { SharedHttpService } from '../../services/shared-http.service';

@Component({
  selector: 'app-case-decision',
  templateUrl: './case-decision.component.html',
  styleUrls: ['./case-decision.component.scss']
})
export class CaseDecisionComponent implements OnInit {

  caseObject: any;
  DecsionTypeArr: any;
  closeResult: string;
  decsionTypeId: any;
  penaltyId: any;
  voteList: any;
  decsionDescription
  decsionId
  lengthVote: any;
  roleId: any;
  DecsionOList: any;
  allowToVote: any;
  PenaltyArr: any;
    amount: any;
    description: any;
    file: any;
  decisionTypeName:string;

  createInvoiceWithAmount: boolean = true;
  isOnCR: boolean = true;
  offenderName: any;
  offenderId: any=null;
    offenderIds: any = [];
    // typeArr: any = [
    //   { id: 1, text: this.sharedService.getTranslatedKey('OnCR'), isSelected: true },
    //   { id: 2, text: this.sharedService.getTranslatedKey('OnPerson'), isSelected: false }
    // ];
  typeArr: any = [
    { id: 1, text: 'OnCR', isSelected: true },
    { id: 2, text: 'OnPerson', isSelected: false }
  ];
  OffenderFromCR: any;
  CasePenaltiesList: any;
  penaltyDescription: any;
  OffenderList: any;
  deleteitem: any;
  casePenaltyId: any;
  penaltyStatusId: any;
  saveDecsion:boolean=false;
  penaltystatusArr: any;
  fileLoad: any;
  FileName: any;
  decsiontypeId: any;
  itemNew: any;
  descriptionDesion: any;
  suggestedDecision: any;
  voteSelect: any;
  signatureSrc: any;
  userIdEncrypt: any;
  constructor(public caseService: CaseService,private route:ActivatedRoute ,public sharedService: SharedHttpService,public router: Router, private modalService: NgbModal,private printDesision:PrintDesionService) {
    this.roleId = this.sharedService.CurrentRoleId;

  }
  ngOnInit(): void {
      let url: any = `api/Lookup/GetLookup?key=decsiontype`;
    this.sharedService.get(url).subscribe(result => {
      this.DecsionTypeArr = result;
      console.log("DecsionTypeArr",this.DecsionTypeArr)
    });
      let urlGet: any = `api/Lookup/GetLookup?key=penaltystatus`;
    this.sharedService.get(urlGet).subscribe(result => {
      this.penaltystatusArr = result;
    });
    let getUrl: any = `api/Penalty/GetAllAsLookup`;
    this.sharedService.get(getUrl).subscribe(result => {
      this.PenaltyArr = result;
    });
 
    this.userIdEncrypt=this.route.snapshot.params['userIdEncrypt'];
    let Url: any = `api/User/GetSignature`;
  
      this.sharedService.getString(Url).subscribe(res => {
          this.signatureSrc = res;
          let user = JSON.parse(localStorage.getItem('user'));
          this.headofcommittee1.sign = this.signatureSrc ? `<img style='width:200px;height:50px' src='data:image/png;base64,${this.signatureSrc}'/>` : "";
          this.headofcommittee1.name = user.displayName;
          console.log(this.headofcommittee1);
          console.log('res',this.signatureSrc)
      });
     

  }
    decsionNumber: any="";
    decsionhijriYear: any = "";
    headofcommittee1: any = {name:"",sign:""};
  loadData() {
    this.caseObject = this.caseService.getCaseData();
    this.allowToVote = this.caseObject.optioans.allowToVote;
    let url: any = `api/Vote/GetCaseVotes?eCaseId=${this.caseObject.caseIdEncrypt}`;
    this.sharedService.get(url).subscribe(result => {
  
      this.voteList = result;
        this.lengthVote = result.length;

        if (this.lengthVote >= 2) {
           
                this.sharedService.getString(`api/user/GetUserSignature?userId=${this.voteList[0].userId}`).subscribe(res1 => {
                    this.voteList[0].sign = res1 ? `<img style='width:200px;height:50px' src='data:image/png;base64,${res1}'/>` : ""; 
                    this.voteList[0].name = this.voteList[0].userDisplayname.replace("عضو اللجنة - ","");
                   // console.log(this.voteList);
                });
            this.sharedService.getString(`api/user/GetUserSignature?userId=${this.voteList[1].userId}`).subscribe(res2 => {
                this.voteList[1].sign = res2 ? `<img style='width:200px;height:50px' src='data:image/png;base64,${res2}'/>` : "";
                this.voteList[1].name = this.voteList[1].userDisplayname.replace("عضو اللجنة - ", "");
                // console.log(this.voteList);
            });
 
        }
   
           
  
         
         
      console.log("roleId", this.roleId);

      // userRoleId =>6 or 7
    });

      let getUrl: any = `api/Decsion/GetCaseDecsion?eCaseId=${this.caseService.getCaseData().eCaseId}`;
    this.sharedService.get(getUrl).subscribe(result => {
      console.log("Decsion", result);
      this.DecsionOList = result;
        if (this.DecsionOList != null) {
            this.decsionId = result.decsionTypeId;
            if (this.decsionTypeId == 1) {
                this.sharedService.get(`api/Case/GetCaseDetails?eCaseId=${this.caseObject.eCaseId}`).subscribe((res) => {
                    console.log("CaseDetails", res);
                    this.suggestedDecision = res.suggestedDecision
                });
                this.decsionDescription = this.suggestedDecision;

            }
            else {
                this.descriptionDesion = result.decsion;

            }
            this.decsionNumber = (result.decsionNumber != null) ? result.decsionNumber : "";
            this.decsionhijriYear = (result.decsionNumber != null) ? result.hijriYear : "";
            this.decsiontypeId = (result.decsionTypeId != null) ? result.decsionTypeId : "";
            console.log("decsiontypeId", this.decsiontypeId);
            if (result.decsionTypeId == 1) {
                this.decisionTypeName = "عدم ثبوت المخالفة";
            }
            if (result.decsionTypeId == 2) {
                this.decisionTypeName = "ثبوت المخالفة";
            }


        }
        else {
            this.descriptionDesion = this.caseObject.suggestedDecision;
            this.suggestedDecision = this.caseObject.suggestedDecision;
        }
    });


    let getList: any = `api/CasePenalty/GetCasePenalties?eCaseId=${this.caseObject.caseIdEncrypt}`;
    this.sharedService.get(getList).subscribe(result => {
      console.log("CasePenaltiesList", result);
      this.CasePenaltiesList = result;


    });
    // this.isOnCR=false;
    if(this.caseObject.offenderTypeId==2){
      this.itemNew = this.typeArr[1];
      this.isAllSelected(this.itemNew);
    }


   

  }
 

   

    otpRequestId: any;

    CreateVote(id, modal) {

        this.voteSelect = id;
        this.decsionTypeId = this.voteSelect;
        let url: any = `api/Vote/InsertCaseVote`;
        this.sharedService.post(url, {
            "decsionTypeId": this.decsionTypeId,
            "caseId": this.caseObject.caseId,

        }).subscribe(response => {
            console.log("response", response);
            this.otpRequestId = response.otpRequestId;
            this.sharedService.openSmall(modal);

        });

   
   
  }

    otp: any;
  voteSelected(){
    // console.log(id)
    this.decsionTypeId=this.voteSelect;
      let url: any = `api/Vote/ValidateVote`;
    this.sharedService.post(url, {
      "OtpRequestId": this.otpRequestId,
      "otp": this.otp,
      
    }).subscribe(response => {
      console.log("response", response);
        if (response == true) {
            this.loadData();
            this.sharedService.showSuccessKey('VoteCreatedSuccessfully')
            this.modalService.dismissAll();
            this.otp = "";
        }
        else {
            this.sharedService.showErrorKey('PleaseCheckTheCodeSent');
        }


        });

   

  }
  OnCreateVote() {
    let url: any = `api/Vote/InsertCaseVote`;
    this.sharedService.post(url, {
      "decsionTypeId": this.decsionTypeId,
      "caseId": this.caseObject.caseId,
      
    }).subscribe(response => {
      console.log("response", response);

      this.loadData();
      this.sharedService.showSuccessKey('VoteCreatedSuccessfully');
    },
    );
    this.modalService.dismissAll();

  }


  DecsionSelected(id){
    console.log('sssssss',id)
      this.decsionId = id;

      this.changeDecsion(id);
  }
    decsended: any = false;
    loading: boolean = false;
    CreateDecsion() {
        this.decsended = true;
        this.loading = true;
    console.log("descriptionDesion",this.descriptionDesion);
    //if(this.decsionTypeId==1){
    ////  this.sharedService.get(`api/Case/GetCaseDetails?eCaseId=${this.caseObject.caseIdEncrypt}`).subscribe((res) => {
    ////    console.log("CaseDetails", res,res.suggestedDecision);
    ////    this.suggestedDecision=res.suggestedDecision
    ////});
    ////this.decsionDescription=this.suggestedDecision;

    //}
    let body =  {
      "decsionTypeId": this.decsionId,
      "caseId": this.caseObject.caseId,
      "decsion": this.descriptionDesion
        };
let url: any = `api/Decsion/InsertCaseDecsion`;
    this.sharedService.post(url,body).subscribe((response) => {
    //  console.log("response", response);
      //let formData: FormData = new FormData();
      //formData.append('statusId', '9');
      //formData.append('description',this.descriptionDesion);
      //formData.append('caseIdEncrypt', this.caseObject.caseIdEncrypt);
      
      //this.sharedService.post('api/Delegate/InsertDelegation', formData).subscribe(
      //  (response) => {                       
          this.saveDecsion=true;
          this.loadData();
          let getUrlDecision: any = `api/Decsion/GetCaseDecsion?eCaseId=${this.caseObject.caseIdEncrypt}`;
          this.sharedService.get(getUrlDecision).subscribe(result => {
            console.log("Decsion", result);
            this.DecsionOList = result;
            this.decsionNumber = result.decsionNumber;
            this.decsionhijriYear = result.hijriYear;
            // let stringToastr =`${this.sharedService.getTranslatedKey("SaveDecsionSuccessfully")} ${this.sharedService.getTranslatedKey("WithNumber")} ${this.decsionNumber} ${this.sharedService.getTranslatedKey("ForYear")} ${this.decsionhijriYear} `
            // this.toastr.showSuccess(stringToastr, this.sharedService.getTranslatedKey("Success"));
              this.modalService.dismissAll();
              this.loading = false;

            this.router.navigate([`/case/decision-done/${this.decsionNumber}`]);
          });
        },
          (error) => {                              
            this.sharedService.showErrorKey('Notsaved');
          }
   );
     

      
    //},(error) => {                              
    //  console.error('error')
      
 
    //}
    //);
  }


    changeDecsion($event) {
        console.log(this.caseObject.optioans.allowToAddPenalties);
        console.log(this.roleId);
        console.log(this.DecsionOList);
console.log($event);
        this.decsiontypeId = $event;
    }
  isAllSelected(item) {
    console.log("mmmmmmm",item)
    this.typeArr.forEach(val => {
      if (val.id == item.id) val.isSelected = !val.isSelected;
      else {
        val.isSelected = false;
      }
    });
    if (item.id == 2) {
      this.isOnCR = false;
      this.sharedService.get(`api/Offender/GetOffenders?eCaseId=${this.caseObject.caseIdEncrypt}`).subscribe(res => {
        this.OffenderList = res;
       // console.log("this.OffenderList",this.OffenderList)
        
       

      })
    } else {
      this.isOnCR = true;
       // this.offenderId = this.caseObject.offenderId;
    }
  }

  isAmount(item){
    if(item==false)
      this.amount=0;
         
  }
 
  selectItem(event) {
    if (event) {
      this.penaltyDescription = event.penaltyDescription;
 this.amount=event.penaltyAmount;

    }
  }
  CreatePenalty(modal) {
 
    this.sharedService.openSmall(modal);
    
  }
    OnCreatePenalty() {
        let url: any = `api/CasePenalty/AddCasePenalty`;
        let casePenaltyOffenders: any = [];
        if (this.offenderIds.length > 0)
            this.offenderIds.forEach(val => {
                casePenaltyOffenders.push({ offenderId: val })
            } );
    this.sharedService.post(url, {
      "isOnCR": this.isOnCR,
      "penaltyId": this.penaltyId,
      "caseId": this.caseObject.caseId,
      "offenderId": this.offenderId,
      "createInvoiceWithAmount": this.createInvoiceWithAmount,
        "amount": this.amount,
        "casePenaltyOffenders": casePenaltyOffenders,
    
    }).subscribe(response => {
      this.loadData();
        this.sharedService.showSuccessKey('PenaltyCreatedSuccessfully');
        this.penaltyId = null;
        this.offenderId = null;
        this.offenderName = null;
        this.createInvoiceWithAmount = false;
        this.penaltyDescription = "";
        this.amount = 0;

    },
    );
    this.modalService.dismissAll();

  } 

  DeletePenalty(item: any, mymodal) {
    this.sharedService.openLarge(mymodal);
    this.deleteitem = item;
  
  }

 

  onDeletePenalty() {
    let url = `api/CasePenalty/DeleteCasePenalty?CasePenaltyId=${this.deleteitem.casePenaltyId}`;
    this.sharedService.get(url).subscribe((res) => {
      console.log("res",res);
      this.modalService.dismissAll();
      this.loadData();

    });
  }

  
  checktype(name) {
    var ext = name.split('.').pop();

    console.log(ext);
    if (ext == "doc"
      || ext == "docx"
      || ext == "xls"
      || ext == "xlsx"
      || ext == "ppt"
      || ext == "pptx"
      || ext == "png"
      || ext == "jpg"
      || ext == "jpeg"
      || ext == "tiff"
      || ext == "pdf"
      || ext == "svg"
      || ext == "bmp"
      || ext == "ico"

    )
      return true;
    else
      return false;
  }


  UploadFile(file: any){
console.log("f", file)
this.fileLoad=file;
this.FileName=file.target.files[0].name;
console.log(file.target.files[0].name);
if (!this.checktype(file.target.files[0].name)) {
  return;
}
}

clear(){
this.fileLoad=undefined;
this.FileName=null;
}
  EditPenalty(item, modal) {
    console.log("item", item);
    this.casePenaltyId=item.casePenaltyId;
    this.penaltyStatusId=item.penaltyStatusId;
    this.sharedService.openSmall(modal);
  }

  onEditPenalty() {
    let formData: FormData = new FormData();
    formData.append('casePenaltyId', this.casePenaltyId);
    formData.append('description',this.description);
    formData.append('penaltyStatusId', this.penaltyStatusId);
    if(this.fileLoad != undefined){
      formData.append('FileName', this.fileLoad.target.files[0].name);
      formData.append('ContentType', this.fileLoad.target.files[0].type);
        formData.append('file', this.fileLoad.target.files[0]);
    }
    let url: any = `api/CasePenalty/UpdateCasePenaltySatus`;
    this.sharedService.post(url,formData).subscribe(result => {
      this.loadData();
    });
    this.modalService.dismissAll();
    }
    Recivers1: any = [];
    ShowRecivers(item, modal) {
        this.Recivers1 = []; 
        this.sharedService.get(`api/Case/GetPenaltyRecivers?casePenaltyId=${item.casePenaltyId}`).subscribe(res => {
            this.Recivers1 = res;
            console.log(this.Recivers1);
            this.sharedService.openLarge(modal);
        });

  }

  PrintDecision() {
    this.printDesision.PrintDecision(this.caseObject.caseIdEncrypt);
  }
    convertNumerals(input: string):string {
        return input.toString().split('0').join('٠')
            .split('1').join('١')
            .split('2').join('٢')
            .split('3').join('٣')
            .split('4').join('٤')
            .split('5').join('٥')
            .split('6').join('٦')
            .split('7').join('٧')
            .split('8').join('٨')
            .split('9').join('٩');
    }
  PreviewDecision(){
    let decisionName;
    if(this.decsionId==1){
      decisionName="عدم ثبوت المخالفة";
    }
    else if(this.decsionId==2){
      decisionName="ثبوت المخالفة";
    }
    else
    decisionName="---";
      
  /*  this.sharedService.get(`api/Case/GetPrint?eCaseId=${this.caseObject.caseIdEncrypt}`).subscribe(res=>{*/



      let res  ;
      let rescase = this.caseObject;
      let respenalites = this.CasePenaltiesList;
      let offenderTypeName;
      let penalities='';
      let memeberUser=[];
      let headOfCommittee;
      let signatureMemberOne;
      let signatureMemberTwo='';
      let SignatueHead='';
        rescase.offenderTypeId == 1 ? offenderTypeName = "سجل تجاري رقم" : offenderTypeName = "رقم الهوية";
        rescase.reasons = ((rescase.reasons == null || rescase.reasons =="null") ? "" : rescase.reasons);
        rescase.facts = ((rescase.facts == null || rescase.facts=="null") ? "" : rescase.facts);
      if(this.decsionTypeId==1){
        penalities='';
      }else{
        respenalites.map((el,index)=>{
          if(el.createInvoiceWithAmount){
              penalities = penalities.concat(`<div>${this.convertNumerals(index + 1)}- ${this.convertNumerals(el.penaltyTitle)} وقيمتها ${this.convertNumerals(el.amount)}   رقم السداد :   ${this.convertNumerals(el.sadadNumber)}</div>`);
              
              
          }else{
              penalities = penalities.concat(`<div>${this.convertNumerals(index + 1)}- ${el.penaltyTitle}</div>`);
             
          }
        });
      }
      //res.users.map(el =>{
      //    el.committeeRoleId == 7 ? memeberUser.push(el) : headOfCommittee = el;

      //})
      //  if (res.decsion.decsion == null) {
      //      res.decsion.decsion = "";
      //  }
     // memeberUser[0].signture ? signatureMemberOne=`<img style='width:100px;height:50px' src='data:image/png;base64,${memeberUser[0].signture}'/>` : signatureMemberOne='';
     // memeberUser[1].signture ? signatureMemberTwo=`<img style='width:100px;height:50px' src='data:image/png;base64,${memeberUser[1].signture}'/>` : signatureMemberTwo='';
     // headOfCommittee.signture ? SignatueHead=`<img style='width:100px;height:50px' src='data:image/png;base64,${headOfCommittee.signture}'/>` : SignatueHead='';
      
      const body = `<div style="display:flex;flex-direction:column;align-items: center; justify-content:center">
      <a style="width:270px;margin:auto;display:flex" class="logo" routerLink='/'>
      <img style="width:30%;margin:auto" class="img-fluid for-light" src="../../../../../assets/images/mclogo.png" alt="looginpage">
      </a>
     
      (مسودة)
      </div>
      <h4 style="font-weight: bold;">${rescase.caseCommitteeName}</h4>
      
      <table style="width: 100%; text-align: center; margin: 20px 0;">
          <tr style="font-weight: bold;">
            <th style="border:1px solid black;">المخالفة رقم</th>
            <th style="border:1px solid black;">رقم القرار</th>
            <th style="border:1px solid black;">تاريخ القرار</th>
          </tr>
          <tr>
            <td style="border:1px solid black;">${rescase.caseNumber}</td>
            <td style="border:1px solid black;">---</td>
            <td style="border:1px solid black;">----------</td>
          </tr>  
      </table>
      <p style="font-size:20px;font-weight:200;">إنه في يوم ---------، اجتمعت ${rescase.caseCommitteeName} ، بمقرها بوزارة التجارة بمدينة الرياض ،
           للنظر فى المخالفة المنسوبة إلى ${rescase.offenderName} ${offenderTypeName} (${this.convertNumerals(rescase.offenderId)})
      </p>
      
      <table style="width: 100%; text-align: center; margin: 30px 0; font-size:16px;">
          <tr style="font-weight: bold;">
            <th style="border:1px solid black;">الوقائع</th>
          </tr>
          <tr>
            <td style="border:1px solid black;text-align:right;">${this.convertNumerals(rescase.facts)}</td>
          </tr>  
      </table>
      
      <table style="width: 100%; text-align: center; margin: 30px 0; font-size:16px;">
          <tr style="font-weight: bold;">
            <th style="border:1px solid black;">الأسباب</th>
          </tr>
          <tr>
            <td style="border:1px solid black;text-align:right;">${this.convertNumerals(rescase.reasons)}
          </td>
          </tr>  
      </table>
      <div style="position: fixed;
      top:5;bottom:5;left:5;right:5;
      display:flex;
      align-items:center;
      justify-content:center;
      overflow:hidden;
      z-index:-9;
      color: #d0d0d0;
   font-size: 203pt;
   opacity: .5;
   -webkit-transform: rotate(-45deg);
   -moz-transform: rotate(-45deg);
   width: 100%
    "> 
     مسودة
   </div>
      <table style="width: 100%;margin: 30px 0; font-size:16px;">
          <tr style="font-weight: bold; text-align: center;">
            <th style="border:1px solid black;">القرار</th>
          </tr>
          <tr>
              <td style="border:1px solid black;">
                 
                  <p>${this.convertNumerals(this.descriptionDesion)}</p><br/>
                  ${this.convertNumerals(penalities)}
              </td>
          </tr>  
      </table>
      <div style="display:flex;justify-content: space-evenly;align-items: center;">
           <div style="width:4000px;text-align: center;">
               <h4>عضو</h4>
                 ${this.voteList[0].sign}
              <p>${this.voteList[0].name}</p>
          
           </div>
           <div style="width:4000px;text-align: center;">
               <h4>عضو</h4>
               ${this.voteList[1].sign}
                <p>${this.voteList[1].name}</p>
               ${this.voteList[1].sign}
           </div>
       </div>
            <div style="display:flex;justify-content: center;align-items: center; margin-top: 10px;">
           <div style="width:4000px;text-align: center;">
               <h4>رئيس لجنة</h4>
                ${this.headofcommittee1.sign}
               <p> ${this.headofcommittee1.name}  </p>

           </div>
       </div>
     `;
  
      let contents = `
        <html>
          <head>
            <style  type="text/css">
           @media print {
  @page { margin: 0; }
  body { margin: 1.0cm; }
}
              @font-face {
                font-family: "Noto Naskh Arabic";
                src: url("../../../../../assets/fonts/Noto_Naskh_Arabic/NotoNaskhArabic-VariableFont_wght.ttf") format("truetype");
              }

body,p,td,th,span,div{  font-family: "AL-Mohanad"; font-size:28px;  }
h1,h2,h3,h4,h5{  font-family: "AL-Mohanad";   }
            </style>
          </head>
          <body dir="rtl"> ${body}</body>
        </html>`;
  
      let mywindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      mywindow.document.open();
      let is_chrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
      mywindow.document.write(contents);
  
      if (is_chrome) {
        setTimeout(function () {
          mywindow.document.close();
          mywindow.focus();
          mywindow.print();
          // mywindow.close();
        }, 1250);
      } else {
        mywindow.document.close();
        mywindow.focus();
        mywindow.print();
        // mywindow.close();
      }
   /* })*/

  }



}
